import React from "react";
import ClientActionModal from "./shared/ClientActionModal";
import useModalLogic from "./hooks/useModalLogic";

function Archive(props) {
  const { clientDetails, clientId } = props;

  const {
    open,
    toggleModal,
    handleClientAction,
    updating,
  } = useModalLogic(clientId);

  const toggleClientArchiveStatus = () => {
    handleClientAction({
      isArchive: !clientDetails?.isArchive,
      isActive: !clientDetails?.isActive,
    });
  };

  return (
    <React.Fragment>
      <button
        type="button"
        className="btn btn-primary waves-effect waves-light w-100 me-1"
        onClick={toggleModal}
        disabled={!clientDetails.isActive && !clientDetails.isArchive}
      >
        {clientDetails.isArchive ? "De-archive Client" : "Archive Client"}
      </button>
      <ClientActionModal
        open={open}
        toggle={toggleModal}
        clientDetails={clientDetails}
        isActive={clientDetails?.isActive}
        isArchive={true}
        onToggle={toggleClientArchiveStatus}
        isLoading={updating}
      />
    </React.Fragment>
  );
}

export default Archive;